export const WISTIA_VIDEOS = {
  SECURITY_SETTINGS: "2t8od4ole9",
  SIP_FILES_FIELD: "533r7ce5f0",
  SIP_FILES_NEW_STARTERS: "rexyfxhgd2",
  SIP_FILES_LEAVERS_REMOVING: "7szd2lf3h2",
  SIP_FILES_POSITION_AND_DEPARTMENT_UPDATES: "xg92b9hhhc",
  EMPLOYEES_INSTRUCTIONS: "38vcxd0lpu",
  ACCOUNT_INSTRUCTIONS: "6kbwcu1osu",
  ABSENCE_DETAILS_INSTRUCTIONS: "eyg4y3zxpy",
  ACTIVITIES_INSTRUCTIONS: "iofrzu3ea6",
  ALERT_DETAILS_INSTRUCTIONS: "5jz358jo8v",
  CARE_PLANS_INSTRUCTIONS: "fs6obv1jg3",
  DASHBOARD_INSTRUCTIONS: "y000szsog5",
  NURSE_ASSESSMENTS_INSTRUCTIONS: "vd3inym3mt",
  RTW_INSTRUCTIONS: "yjxn7z7klo",
  TASKS_INSTRUCTIONS: "8zcw7jvsmh",
  WELLBEING_ADVICE_INSTRUCTIONS: "d2m1o0qba1",
  WORK_FORCE_INSTRUCTIONS: "dcubzbrjvj",
  ALERTS_INSTRUCTIONS: "t3ury0epmu",
  SERVICE_INSTRUCTIONS: "g34a0bo5s8",
  EMPLOYEE_CONTACTS_INSTRUCTIONS: "5u4q1c2wcs",
  EMPLOYEE_ABSENCES_INSTRUCTIONS: "caxv4c7mm1",
};
